<template>
  <div>
    <base-select
    v-show="options.length"
    v-model="_value"
    v-validate="options.length ? 'required' : ''"
    :name="name"
    :options="options"
    :validations="validations"
    :clearable="false"
    :searchable="searchable"
    :appendToBody="appendToBody"
    :placeholder="'* ' + $t('Chose your province')"
    >
      <template #option="opt">
        <slot name="option" v-bind="opt" />
      </template>
    </base-select>
    <base-input
      v-show="!options.length"
      v-validate="!options.length ? 'required' : ''"
      :name="name"
      type="text"
      v-model="_value"
      :validations="validations"
      :placeholder="'* ' + $t('address.Province')"
      />
  </div>
</template>

<script>
import find from 'lodash/find'
import debounce from 'lodash/debounce'
import uniqBy from 'lodash/uniqBy'
import Config from '@/config'
import BaseInput from 'theme/components/Form/BaseInput'
import BaseSelect from 'theme/components/Form/BaseSelect'

export default {
  name: 'SelectProvince',
  inject: ['$validator'],
  props: {
    name: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: [String, Number, Object],
      default: () => ''
    },
    countryId: {
      type: String,
      default: () => Config.Theme.default.country
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    },
    searchable: {
      type: Boolean,
      default: () => true
    },
    appendToBody: {
      type: Boolean,
      default: () => false
    },
    reduce: {
      type: Function
    },
    optionLabel: {
      type: String,
      default: () => 'label'
    }
  },
  mounted () {
    this.$store.dispatch('checkout/loadCountries')
  },
  computed: {
    available_regions () {
      if (this.$store.state.checkout && this.$store.state.checkout.countries.length > 0) {
        const countryFound = find(this.$store.state.checkout.countries, { 'id': this.countryId })
        if (countryFound && countryFound.available_regions) {
          return uniqBy(countryFound.available_regions, 'name')
        } else {
          return []
        }
      }
      return []
    },
    _value: {
      get () {
        return this.value
      },
      set: debounce(function (newValue) {
        this.$emit('input', newValue)
      }, 500)
    },
    options () {
      if (this.available_regions) {
        return this.available_regions.map((item, index) => ({ key: index, code: item.code, label: item.name }))
      } else {
        return this.available_regions
      }
    }
  },
  components: {
    BaseSelect,
    BaseInput
  }
}
</script>
